export class HowItWorks {
    store;

    async init(store) {
        this.store = store;
        await this._initTryFreeButton();
    }

    async _initTryFreeButton() {
        const tryFreeButton: HTMLButtonElement = document.querySelector('.how-it-works__button--try-free');

        tryFreeButton.addEventListener('click', (event) => {
            this.store.dispatch('modalManagementSystem/addModalWindow', {
                content: 'FormConvertFlow',
            })
        })
    }
}